/**
 * @param {number} msRemaining
 * @returns {string} e.g. "12:40" or "0:00"
 */
export function formatCountdown(msRemaining) {
  const totalSecs = Math.max(0, Math.floor(msRemaining / 1000));
  const mins = Math.floor(totalSecs / 60);
  const secs = totalSecs % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
}

/**
 * @param {string | null | undefined} iso
 * @param {number} [nowMs]
 * @returns {number | null} remaining ms until ISO next_publish_at; null if missing/invalid
 */
export function msUntil(iso, nowMs = Date.now()) {
  if (!iso) return null;
  const target = Date.parse(iso);
  if (!Number.isFinite(target)) return null;
  return Math.max(0, target - nowMs);
}

/**
 * Claim must stay disabled while a frozen root is still awaiting on-chain submit.
 * @param {object | null | undefined} publishStatus
 * @param {number | null | undefined} epoch
 */
export function claimBlockedByPendingChain(publishStatus, epoch) {
  if (!publishStatus?.pending_chain || epoch == null) return false;
  const pending = Number(publishStatus.pending_epoch);
  const claimEpoch = Number(epoch);
  return Number.isFinite(pending) && Number.isFinite(claimEpoch) && pending === claimEpoch;
}

/**
 * Prefer publish-status latest_epoch; fall back to URL override then 1.
 * @param {object | null | undefined} publishStatus
 * @param {number} urlEpoch
 */
export function resolveStreakEpoch(publishStatus, urlEpoch) {
  const fromStatus = publishStatus?.latest_epoch;
  if (fromStatus != null && Number(fromStatus) > 0) {
    return Math.floor(Number(fromStatus));
  }
  if (urlEpoch > 0) return Math.floor(urlEpoch);
  return 1;
}
